export default class DocumentVersion {
	_currentVersion;

	constructor(currentVersion) {
		this._currentVersion = typeof currentVersion === "object" ? currentVersion.version : currentVersion;
	}

	get minorVersion() {
		return this.currentVersion.slice(0).replace(/^(\d+\.)(\d+)$/, (match, g1, g2) => `${g1}${parseInt(g2) + 1}`);
	}

	get majorVersion() {
		return this.currentVersion.slice(0).replace(/^(\d+)\.\d+$/, (match, g1) => `${parseInt(g1) + 1}.0`);
	}

	get currentVersion() {
		return this._currentVersion;
	}

	set currentVersion(value) {
		this._currentVersion = value;
	}
}
